import Vue from 'vue';
import { orderBy } from 'lodash-es';

export default {
  namespaced: true,
  state: {
    loadingStatus: 'init',
    all: {},
    // order: [],  // TODO: Handle sorting with Firebase
  },
  getters: {
    teamMembersAreLoaded: (state) => state.loadingStatus === 'init-loaded'
      || state.loadingStatus === 'snapshot-loaded',
    teamMembersInitLoaded: (state) => state.loadingStatus !== 'init' && state.loadingStatus !== 'init-loading',
    allSortedTeamMembers: (state) => orderBy(Object.values(state.all), ['type', 'name'], ['asc']),
  },
  mutations: {
    RESET_STATE(state) {
      state.loadingStatus = 'init';
      state.all = {};
    },
    SET_LOADING_STATUS(state, loadingStatus) {
      state.loadingStatus = loadingStatus;
    },
    SET_TEAM_MEMBER(state, { id, ...data }) {
      const teamMember = { ...data };

      // Read-only id property
      Object.defineProperty(teamMember, 'id', {
        value: id,
        enumerable: true,
      });
      Vue.set(state.all, id, teamMember);
    },
    REMOVE_TEAM_MEMBER(state, id) {
      Vue.delete(state.all, id);
    },
  },
  actions: {
    async onSnapshot({ state, commit }, { snapshot, replaceExistingState = false }) {
      let docIdsToRemove = []; // Documents to remove
      if (replaceExistingState) docIdsToRemove = Object.keys(state.all);

      // Set loading status
      if (state.loadingStatus === 'init') commit('SET_LOADING_STATUS', 'init-loading');
      else commit('SET_LOADING_STATUS', 'snapshot-loading');

      snapshot.docChanges().forEach((snapshotChange) => {
        if (snapshotChange.type === 'added' || snapshotChange.type === 'modified') {
          commit('SET_TEAM_MEMBER', {
            id: snapshotChange.doc.id,
            ...snapshotChange.doc.data(),
          });

          if (replaceExistingState) docIdsToRemove = docIdsToRemove.filter((docId) => docId !== snapshotChange.doc.id);
        } else if (snapshotChange.type === 'removed') {
          commit('REMOVE_TEAM_MEMBER', snapshotChange.doc.id);
        }
      });

      // Cleanup existing state
      docIdsToRemove.forEach((docIdToRemove) => commit('REMOVE_TEAM_MEMBER', docIdToRemove));

      // Set loading status
      if (state.loadingStatus === 'init-loading') commit('SET_LOADING_STATUS', 'init-loaded');
      else commit('SET_LOADING_STATUS', 'snapshot-loaded');
    },
  },
};
